module.exports = __webpack_public_path__ + "img/tlos_eosio.token.cf09df9.png";